import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { cn } from "@/lib/utils";

/**
 * shadcn Select with a simple options API for forms and filters.
 *
 * `options` is [{ value, label }]. Use empty string as value for an "all/none"
 * option — it is mapped to "__empty__" internally (Radix forbids "").
 */
export function FormSelect({
  id,
  name,
  value,
  onValueChange,
  options = [],
  placeholder = "Select…",
  disabled = false,
  className,
  triggerClassName,
}) {
  const toInternal = (v) => (v === "" || v == null ? "__empty__" : String(v));
  const fromInternal = (v) => (v === "__empty__" ? "" : v);

  return (
    <Select
      value={toInternal(value)}
      onValueChange={(next) => onValueChange?.(fromInternal(next))}
      disabled={disabled}
      name={name}
    >
      <SelectTrigger
        id={id}
        className={cn("w-full", triggerClassName)}
      >
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent position="popper" className={className}>
        {options.map((opt) => (
          <SelectItem key={String(opt.value)} value={toInternal(opt.value)}>
            {opt.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
